import formatISO from 'date-fns/formatISO';

export const INITIAL_VALUES = {
  author: '',
  date: formatISO(new Date(), { representation: 'date' }),
  manager: undefined,
  email: undefined,
  phoneNumber: undefined,
  department: undefined,
  description: '',

  safety: false,
  quality: false,

  movementDecrease: false,
  waitingDecrease: false,
  transportationDecrease: false,
  correctionDecrease: false,
  additionalProcessDecrease: false,
  excessProductionDecrease: false,
  reservesLossDecrease: false,

  currentSituationDescription: '',
  currentSituationImages: [],
  futureSituationDescription: '',
  futureSituationImages: [],

  mainProblemFix: '',
  standardization: '',
};
